import { makeStyles, Theme } from '@material-ui/core/styles';
import { StylesProps } from '../../models/StylesProps';
import { marginBottomAndTop } from '../../styles/globals';

const bkgColors = (theme: Theme) => ({ firstColor: theme.palette.brand.blue, secondColor: theme.palette.brand.lightBlue });

export const useCustomerOpinionsStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: `linear-gradient(to right, ${bkgColors(theme).firstColor} 0%, ${bkgColors(theme).firstColor} 52%, ${
      bkgColors(theme).secondColor
    } 52%, ${bkgColors(theme).secondColor} 100%)`,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      background: `linear-gradient(to bottom, ${bkgColors(theme).firstColor} 0%, ${bkgColors(theme).firstColor} 52%, ${
        bkgColors(theme).secondColor
      } 52%, ${bkgColors(theme).secondColor} 100%)`
    }
  },
  video: {
    background: bkgColors(theme).firstColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 30,
    borderRadius: '50%',
    [theme.breakpoints.down('xs')]: {
      padding: 33,
      background: bkgColors(theme).secondColor,
      justifyContent: 'center'
    }
  },

  constainerDescriptions: {
    color: theme.palette.common.white,
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    padding: 37,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: 30
    }
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 414,
    height: 414,
    borderRadius: '50%',
    '& .image-button': {
      color: 'white',
      width: 100,
      height: 100
    },
    [theme.breakpoints.down('xs')]: {
      width: 244,
      height: 244
    }
  },
  constainerInformations: {
    width: '40%',
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 56,
    '& div': {
      width: 313
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      paddingLeft: 0,
      margin: 30,
      minHeight: '232px !important',
      '& div': {
        width: '100%'
      }
    }
  },
  butonPlay: {
    width: 100,
    height: 100,
    border: `3px solid ${theme.palette.common.white}`,
    borderRadius: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white
  }
}));

export const useCustomerOpinionsContainerStyles = makeStyles((theme) => ({
  root: ({ marginTop, marginBottom, tabletMarginBottom, tabletMarginTop, mobileMarginBottom, mobileMarginTop }: StylesProps) => ({
    width: '100% ',
    display: 'flex',
    ...marginBottomAndTop(marginTop, marginBottom),
    background: `linear-gradient(to right, ${bkgColors(theme).firstColor} 0%, ${bkgColors(theme).firstColor} 54%, ${
      bkgColors(theme).secondColor
    } 54%, ${bkgColors(theme).secondColor} 100%)`,
    [theme.breakpoints.down('xs')]: {
      background: theme.palette.primary.main,
      ...marginBottomAndTop(mobileMarginTop, mobileMarginBottom),
      [theme.breakpoints.only('md')]: {
        ...marginBottomAndTop(tabletMarginTop, tabletMarginBottom)
      }
    }
  })
}));
